module.exports = __webpack_public_path__ + "e544ba81f4d30b32725501a2a523836b.svg";